import { createSetState, createStore } from '@flowus/common/zustand/utils';

type SubscribeRecord = Record<string, boolean>;

const subscribeStore = createStore<SubscribeRecord>(() => ({}));

const setSubscribeStore = createSetState(subscribeStore, { assign: true });

export const useSubscribeStatus = (id: string) => {
  return !!subscribeStore((s) => {
    return s[id];
  });
};

export const setSubscribeStatus = (id: string, isSubscribed: boolean) => {
  setSubscribeStore({
    [id]: isSubscribed,
  });
};
